/**
 * Case-related constants.
 *
 * These mirror the constants defined on the backend WawCase model
 * (app/Models/WawCase.php) and the `is_draft` / `is_web_booking`
 * semantics used throughout the V2 case flows.
 *
 * `is_web_booking` values:
 *  - PRECASE_REQUEST    (-1)  Case created via the wizard with special requests (manual pre-case).
 *  - REGULAR_CASE        (0)  Regular, confirmed case (not a pre-case).
 *  - PRECASE_CONFIRMED   (1)  Pre-case confirmed from the website.
 *
 * `is_draft` values:
 *  - false  Case is finalised (sold / confirmed).
 *  - true   Case is a draft pre-case (manual or from website).
 */
export enum WebBooking {
  PRECASE_REQUEST = -1,
  REGULAR_CASE = 0,
  PRECASE_CONFIRMED = 1,
}

/**
 * Whether a case is a pre-case (draft).
 *
 * A case is considered a pre-case when any of the following is true:
 *  - `is_pre_case` is `true` (definitive flag from the API)
 *  - `is_web_booking` is `PRECASE_REQUEST` (-1)
 *  - `is_web_booking` is `PRECASE_CONFIRMED` (1)
 *  - `is_draft` is truthy
 */
export const isPreCaseStatus = (caseData: {
  is_pre_case?: boolean | null;
  is_web_booking?: number | string | null;
  is_draft?: boolean | number | null;
} | null | undefined): boolean => {
  if (!caseData) return false;
  if (caseData.is_pre_case === true) return true;
  const webBooking = Number(caseData.is_web_booking);
  return webBooking === WebBooking.PRECASE_REQUEST
    || webBooking === WebBooking.PRECASE_CONFIRMED
    || !!caseData.is_draft;
};
